import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=473f382b&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=473f382b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f382b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('473f382b')) {
      api.createRecord('473f382b', component.options)
    } else {
      api.reload('473f382b', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=473f382b&scoped=true&", function () {
      api.rerender('473f382b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ROmaAxIODAfs/JS/comp/PopupDialog.vue"
export default component.exports